import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { invalidateTimeEntries } from './keys';
import { ITimeEntry } from './types';

interface IOpenBlockedDayVariables {
	userId: string;
	day: string;
	reason: string;
}

export const useOpenBlockedDayMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: unknown) => void;
	onSuccess?: (data: ITimeEntry) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userId, day, reason }: IOpenBlockedDayVariables) =>
			userSession.webServiceHelper.callAsync<ITimeEntry>(
				`TimeEntry/users/${encodeURIComponent(userId)}/days/${encodeURIComponent(day)}/openBlocked`,
				'POST',
				{
					comment: reason,
				}
			),
		onError,
		onSuccess,
		onSettled: () => invalidateTimeEntries(),
	});
};
